export const openExport = (res) => {
    const { blob, filename } = res;
    const url = window.URL.createObjectURL(blob);

    // Create a temporary link to trigger the download with set filename
    const tempAnchor = document.createElement('a');
    tempAnchor.href = url;
    tempAnchor.download = filename;
    document.body.appendChild(tempAnchor);
    tempAnchor.click();

    // Clean up the URL object
    document.body.removeChild(tempAnchor);
    window.URL.revokeObjectURL(url);

    return;
}

export const exportResponseHandler = (defaultFileName = "Export.csv") => async (response) => {
    const blob = await response.blob();
    const disposition = response.headers.get('content-disposition');
    let filename = defaultFileName;
    if (disposition == null)
        return filename;
    
    const fileNameStarRegex = /(?<=filename\*=UTF-8'')([^;]+)/i;
    const matchesStar = disposition.match(fileNameStarRegex);

    if (matchesStar && matchesStar[1]) {
        filename = decodeURIComponent(matchesStar[1].trim());
    } else {
        console.error("Cannot extract filename");
    }

    return { blob, filename };
}